function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.375 8C12.343 7.91785 12.2968 7.83906 12.2302 7.78097C12.1637 7.72288 12.083 7.69024 12 7.69024C11.917 7.69024 11.8363 7.72288 11.7698 7.78097C11.7032 7.83906 11.657 7.91785 11.625 8C11.625 8 11.625 8 11.625 8C11.5417 8.21667 11.4667 8.43333 11.4 8.65C11.1333 9.51667 11 10.3833 11 11.25C11 14.2833 11.1815 17.3167 11.5444 20.35C11.5704 20.5667 11.5972 20.7833 11.625 21C11.6371 21.0933 11.6783 21.1827 11.7474 21.2487C11.8164 21.3147 11.9067 21.3517 12 21.3517C12.0933 21.3517 12.1836 21.3147 12.2526 21.2487C12.3217 21.1827 12.3629 21.0933 12.375 21C12.4028 20.7833 12.4296 20.5667 12.4556 20.35C12.8185 17.3167 13 14.2833 13 11.25C13 10.3833 12.8667 9.51667 12.6 8.65C12.5333 8.43333 12.4583 8.21667 12.375 8Z",
  fill: "#992E2F"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 7,
  r: 4,
  fill: "#FF4D4F",
  stroke: "#992E2F",
  strokeWidth: 1.6
});

var SvgLocator = function SvgLocator(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLocator, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/locator.36664571.svg";
export { ForwardRef as ReactComponent };